var map = {
	"./Ambulance.png": 1089,
	"./Ask A Doctor.png": 1090,
	"./Blood Cells.png": 1091,
	"./Brain.png": 1092,
	"./Dental.png": 1093,
	"./Depression.png": 1094,
	"./Diagnostics.png": 1095,
	"./Disabled.png": 1096,
	"./Doctor.png": 669,
	"./Ear.png": 1097,
	"./Hospital.png": 1098,
	"./Injection.png": 1099,
	"./Medical Book.png": 1100,
	"./Medical Folder.png": 1101,
	"./Mouth.png": 1102,
	"./Online Claim.png": 1103,
	"./Online Pharmacy.png": 1104,
	"./Optometry.png": 1105,
	"./Pill Bottle.png": 1106,
	"./Podiatry.png": 1107,
	"./Price Tag.png": 1108,
	"./Radiation Theraphy.png": 1109,
	"./Savings.png": 1110,
	"./Symptom List.png": 1111
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1088;